"use client"

import { useSession } from "next-auth/react"
import { Button } from "@/components/ui/button"
import { Shield, X } from "lucide-react"
import { useState } from "react"
import { useRouter } from "next/navigation"

export function ImpersonationBanner() {
  const { data: session } = useSession()
  const [isEnding, setIsEnding] = useState(false)
  const router = useRouter()

  // Only show banner if currently impersonating
  if (!session?.user?.impersonating) {
    return null
  }

  const handleEndImpersonation = async () => {
    try {
      setIsEnding(true)
      
      const response = await fetch('/api/admin/end-impersonate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      
      if (!response.ok) {
        const error = await response.json()
        throw new Error(error.error || 'Failed to end impersonation')
      }
      
      // Reload the page to refresh the session
      window.location.href = '/dashboard'
    } catch (error) {
      console.error('Failed to end impersonation:', error)
      alert('Failed to end impersonation: ' + error.message)
    } finally {
      setIsEnding(false)
    }
  }

  return (
    <div className="bg-yellow-500 dark:bg-yellow-600 text-black px-4 py-2 shadow-md">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <Shield className="h-5 w-5" />
          <span className="font-medium">
            Impersonating: <strong>{session.user.email}</strong>
          </span>
          {session.user.originalUserEmail && (
            <span className="text-sm opacity-75">
              (Admin: {session.user.originalUserEmail})
            </span>
          )}
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={handleEndImpersonation}
          disabled={isEnding}
          className="bg-white hover:bg-gray-100 text-black border-black"
        >
          {isEnding ? (
            <>Ending...</>
          ) : (
            <>
              <X className="mr-1 h-4 w-4" />
              End Impersonation
            </>
          )}
        </Button>
      </div>
    </div>
  )
}